// src/components/Navbar.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';

const navLinks = [
  { label: 'Home', to: 'hero' },
  { label: 'About', to: 'about' },
  { label: 'Services', to: 'services' },
  { label: 'Contact', to: 'contact' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  const handleNavClick = () => {
    setMenuOpen(false);
  };

  return (
    <nav
      className="navbar navbar-expand-lg fixed-top overflow-hidden"
      style={navbarStyle(scrolled)}
    >
      <div className="container" style={{ maxWidth: 1200 }}>
        {/* ── Brand / Logo ── */}
        <a
          className="navbar-brand d-flex align-items-center gap-2 text-decoration-none"
          href="#hero"
        >
          <span style={{ fontSize: 28, lineHeight: 1 }}>
            <img
              src="Logo.png"
              alt="Brain Icon"
              style={{ width: 'auto', height: 48 }}
            />
          </span>

          <div>
            <div style={logoText}>VIHA MindCare</div>
            <div style={logoTagline}>Psychology Centre</div>
          </div>
        </a>

        {/* ── Custom React-controlled toggler ── */}
        <button
          className="navbar-toggler border-0 shadow-none"
          type="button"
          aria-label="Toggle navigation"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? (
            <span
              style={{
                fontSize: '30px',
                fontWeight: 500,
                color: '#1B3F6E',
                lineHeight: 1,
              }}
            >
              ✕
            </span>
          ) : (
            <span
              className="navbar-toggler-icon"
              style={{
                filter:
                  'invert(22%) sepia(60%) saturate(800%) hue-rotate(190deg)',
              }}
            />
          )}
        </button>

        {/* ── Collapsible menu ── */}
        <div
          className={`navbar-collapse collapse ${
            menuOpen ? 'show' : ''
          }`}
          id="vihaNavMenu"
        >
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center gap-lg-3">
            {navLinks.map((link) => (
              <li className="nav-item" key={link.to}>
                <Link
                  to={link.to}
                  smooth={true}
                  duration={600}
                  offset={-80}
                  spy={true}
                  onClick={handleNavClick}
                  className="nav-link px-1"
                  activeClass="viha-nav-active"
                  style={navLinkStyle}
                >
                  {link.label}
                </Link>
              </li>
            ))}

            {/* CTA Button */}
            <li className="nav-item mt-3 mt-lg-0 ms-lg-3">
              <Link
                to="contact"
                smooth={true}
                duration={600}
                offset={-80}
                onClick={handleNavClick}
                className="btn-viha-primary d-block d-lg-inline-block text-center"
                style={{
                  fontSize: 14,
                  padding: '10px 24px',
                  whiteSpace: 'nowrap',
                }}
              >
                Book a Session
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <style>{`
        .viha-nav-active {
          color: #1B3F6E !important;
          border-bottom: 2px solid #5A9E4B;
        }

        .nav-link:hover {
          color: #5A9E4B !important;
        }

        @media (max-width: 991.98px) {
          #vihaNavMenu {
            background: #fff;
            border-top: 1px solid #D6E8F7;
            padding: 16px 8px 24px;
          }

          .nav-link {
            padding: 10px 4px !important;
            border-bottom: 1px solid #f0f4f8;
          }

          .navbar-collapse.show {
            display: block;
          }
        }
      `}</style>
    </nav>
  );
};

/* ── Styles ── */

const navbarStyle = (scrolled) => ({
  backgroundColor: scrolled
    ? 'rgba(255,255,255,0.97)'
    : 'rgba(255,255,255,0.88)',
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
  boxShadow: scrolled
    ? '0 2px 20px rgba(27,63,110,0.12)'
    : 'none',
  borderBottom: scrolled
    ? '1px solid rgba(214,232,247,0.8)'
    : '1px solid transparent',
  transition: 'all 0.35s ease',
  minHeight: 72,
  zIndex: 1030,
});

const logoText = {
  fontFamily: "'Lato', sans-serif",
  fontWeight: 800,
  fontSize: 20,
  color: '#1B3F6E',
  lineHeight: 1.2,
};

const logoTagline = {
  fontFamily: "'Lato', sans-serif",
  fontSize: 14,
  fontWeight: 700,
  letterSpacing: 2,
  color: '#5A9E4B',
};

const navLinkStyle = {
  fontFamily: "'Lato', sans-serif",
  fontWeight: 600,
  fontSize: 15,
  color: '#2C2C2C',
  cursor: 'pointer',
  borderBottom: '2px solid transparent',
  transition: 'color 0.25s ease, border-color 0.25s ease',
};

export default Navbar;